import ItemCollection from '../collections/items'

// Singleton Item collection and cache
export default new ItemCollection()
